export const SAMPLES = {
  normal: {
    label: "Sample 1 — Normal Eye (Haigis range)",
    patient_name: "Demo Patient A",
    age: 68,
    prior_surgery: "none",
    target_refraction: 0,
    od: { k1: 43.25, k1_axis: 6, k2: 44.10, k2_axis: 96, al: 23.62, acd: 3.12, lt: 4.42, wtw: 11.9 },
    os: { k1: 43.18, k1_axis: 8, k2: 44.05, k2_axis: 98, al: 23.68, acd: 3.10, lt: 4.44, wtw: 11.9 },
  },
  anisometropia: {
    label: "Sample 2 — AL Anisometropia (Alert)",
    patient_name: "Demo Patient B",
    age: 72,
    prior_surgery: "none",
    target_refraction: 0,
    od: { k1: 43.90, k1_axis: 12, k2: 45.10, k2_axis: 102, al: 23.10, acd: 3.00, lt: 4.50, wtw: 11.7 },
    os: { k1: 43.80, k1_axis: 10, k2: 45.00, k2_axis: 100, al: 23.55, acd: 3.05, lt: 4.48, wtw: 11.7 },
  },
  postLasik: {
    label: "Sample 3 — Post-LASIK Myopic (Barrett True-K)",
    patient_name: "Demo Patient C",
    age: 55,
    prior_surgery: "lasik_myopic",
    target_refraction: 0,
    od: { k1: 39.80, k1_axis: 4, k2: 40.20, k2_axis: 94, al: 26.20, acd: 3.55, lt: 4.25, wtw: 12.1 },
    os: { k1: 39.75, k1_axis: 6, k2: 40.15, k2_axis: 96, al: 26.25, acd: 3.58, lt: 4.24, wtw: 12.1 },
  },
};
